import script from "./ProductCardMMT.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCardMMT.vue?vue&type=script&setup=true&lang=js"

import "./ProductCardMMT.vue?vue&type=style&index=0&id=3a8150a4&scoped=true&lang=css"
import "./ProductCardMMT.vue?vue&type=style&index=1&id=3a8150a4&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a8150a4"]])

export default __exports__